import { render } from "storyblok-rich-text-react-renderer"

const RichText = ({ children }) => {
    return render(children)
}

export default RichText